import { Theme } from '@mui/material'

import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    display: 'flex',
    gap: theme.spacing(4),
  },
  formWidth: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4),
    width: '70%',
  },
  topContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: theme.palette.text.white,
    padding: theme.spacing(2),
    borderRadius: theme.spacing(1),
  },
  imageContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
  },
  hubspotIcon: {
    height: theme.spacing(3),
    width: theme.spacing(10.25),
  },
  salesforceIcon: {
    height: theme.spacing(5.5),
    width: theme.spacing(7.625),
  },
  cloudContainer: {
    display: 'flex',
    gap: theme.spacing(3),
  },
  accountSelectorWidth: {
    width: theme.spacing(27.5),
  },

  // Bottom Container
  bottomContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
  },
  loadingSpinner: {
    color: `${theme.palette.button.secondary} !important`,
    width: '20px !important',
    height: '20px !important',
    marginLeft: 'auto',
    marginRight: 'auto',
    opacity: 1,
  },

  // Activity Log
  activityLogWidth: {
    backgroundColor: theme.palette.text.white,
    borderRadius: theme.spacing(1),
    width: '30%',
    height: theme.spacing(56.5),
  },
  rootContainer: {
    display: 'flex',
    padding: theme.spacing(4),
    flexDirection: 'column',
    height: theme.spacing(57.75),
  },
  headingContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    alignSelf: 'stretch',
  },
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
  },
  titleIconContainer: {
    display: 'flex',
    height: theme.spacing(3.5),
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: theme.spacing(1.25),
    backgroundColor: theme.palette.textBackground.main,
    borderRadius: theme.spacing(0.5),
  },
  titleIcon: {
    color: theme.palette.labraText.primary,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 500,
    padding: theme.spacing(0, 1),
  },
  heading: {
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '24px',
    color: theme.palette.labraText.primary,
    fontFamily: theme.typography.fontFamily,
    letterSpacing: '0.15px',
  },
  svgBackground: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: theme.spacing(45),
  },
  labraIcon: {
    height: theme.spacing(9.75),
    width: theme.spacing(26.75),
  },
  activityHeading: {
    marginTop: theme.spacing(2),
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px',
    color: theme.palette.textField.main,
    fontFamily: theme.typography.fontFamily,
    letterSpacing: '0.25px',
  },
}))
